<!--
  ==================== 共用组件 ====================
  该组件为商家端和管理员端共用
  根据用户角色（role）动态显示不同的菜单
  - role = 1: 商家端菜单
  - role = 0: 管理员端菜单
  ================================================
-->
<template>
  <div class="layout-container">
    <!-- 顶部导航栏 -->
    <header class="layout-header">
      <div class="header-content">
        <h1 class="logo">后台管理系统</h1>
        <div class="user-info">
          <span>{{ username }}</span>
          <button class="logout-btn" @click="logout">退出登录</button>
        </div>
      </div>
    </header>
    
    <!-- 主体内容区 -->
    <div class="layout-main">
      <!-- 左侧侧边栏 -->
      <aside class="layout-aside">
        <nav class="nav-menu">
          <!-- 商家菜单 (role === 1) -->
          <ul v-if="role === 1">
            <li class="nav-item" :class="{ active: $route.path === '/index' }" @click="navigate('/index')">
              <i class="el-icon-s-home nav-icon"></i>
              <span class="nav-text">首页</span>
            </li>
            <li class="nav-item" :class="{ active: $route.path.startsWith('/product') }" @click="navigate('/product')">
              <i class="el-icon-s-goods nav-icon"></i>
              <span class="nav-text">商品管理</span>
            </li>
            <li class="nav-item" :class="{ active: $route.path.startsWith('/order') }" @click="navigate('/order')">
              <i class="el-icon-s-order nav-icon"></i>
              <span class="nav-text">订单管理</span>
            </li>
            <li class="nav-item" :class="{ active: $route.path.startsWith('/shop') }" @click="navigate('/shop')">
              <i class="el-icon-s-shop nav-icon"></i>
              <span class="nav-text">店铺装修</span>
            </li>
            <li class="nav-item" :class="{ active: $route.path.startsWith('/presale') }" @click="navigate('/presale')">
              <i class="el-icon-s-marketing nav-icon"></i>
              <span class="nav-text">预售管理</span>
            </li>
            <li class="nav-item" :class="{ active: $route.path.startsWith('/stock-warning') }" @click="navigate('/stock-warning')">
              <i class="el-icon-warning-outline nav-icon"></i>
              <span class="nav-text">库存预警</span>
            </li>
            <li class="nav-item" :class="{ active: $route.path.startsWith('/merchant/wallet') }" @click="navigate('/merchant/wallet')">
              <i class="el-icon-coin nav-icon"></i>
              <span class="nav-text">钱包管理</span>
            </li>
            <li class="nav-item" :class="{ active: $route.path.startsWith('/merchant/payment-log') }" @click="navigate('/merchant/payment-log')">
              <i class="el-icon-document nav-icon"></i>
              <span class="nav-text">订单流水</span>
            </li>
          </ul>
          <!-- 管理员菜单 (role === 0) -->
          <ul v-else-if="role === 0">
            <li class="nav-item" :class="{ active: $route.path === '/admin/index' }" @click="navigate('/admin/index')">
              <i class="el-icon-s-home nav-icon"></i>
              <span class="nav-text">控制台</span>
            </li>
            <li class="nav-item" :class="{ active: $route.path.startsWith('/admin/users') }" @click="navigate('/admin/users')">
              <i class="el-icon-user-solid nav-icon"></i>
              <span class="nav-text">用户管理</span>
            </li>
            <li class="nav-item" :class="{ active: $route.path.startsWith('/admin/merchants') }" @click="navigate('/admin/merchants')">
              <i class="el-icon-s-shop nav-icon"></i>
              <span class="nav-text">商家管理</span>
            </li>
            <li class="nav-item" :class="{ active: $route.path.startsWith('/admin/products') }" @click="navigate('/admin/products')">
              <i class="el-icon-s-goods nav-icon"></i>
              <span class="nav-text">商品管理</span>
            </li>
            <li class="nav-item" :class="{ active: $route.path.startsWith('/admin/categories') }" @click="navigate('/admin/categories')">
              <i class="el-icon-menu nav-icon"></i>
              <span class="nav-text">分类管理</span>
            </li>
            <li class="nav-item" :class="{ active: $route.path.startsWith('/admin/orders') }" @click="navigate('/admin/orders')">
              <i class="el-icon-s-order nav-icon"></i>
              <span class="nav-text">订单管理</span>
            </li>
            <li class="nav-item" :class="{ active: $route.path.startsWith('/admin/payment-log') }" @click="navigate('/admin/payment-log')">
              <i class="el-icon-document nav-icon"></i>
              <span class="nav-text">订单流水</span>
            </li>
            <li class="nav-item" :class="{ active: $route.path.startsWith('/admin/ads') }" @click="navigate('/admin/ads')">
              <i class="el-icon-picture-outline nav-icon"></i>
              <span class="nav-text">广告管理</span>
            </li>
            <li class="nav-item" :class="{ active: $route.path.startsWith('/admin/complaints') }" @click="navigate('/admin/complaints')">
              <i class="el-icon-chat-line-square nav-icon"></i>
              <span class="nav-text">投诉处理</span>
            </li>
            <li class="nav-item" :class="{ active: $route.path.startsWith('/admin/presale') }" @click="navigate('/admin/presale')">
              <i class="el-icon-s-marketing nav-icon"></i>
              <span class="nav-text">预售管理</span>
            </li>
            <li class="nav-item" :class="{ active: $route.path.startsWith('/admin/stock-warning') }" @click="navigate('/admin/stock-warning')">
              <i class="el-icon-warning-outline nav-icon"></i>
              <span class="nav-text">库存预警</span>
            </li>
          </ul>
        </nav>
      </aside>
      
      <!-- 右侧主内容 -->
      <main class="layout-content">
        <router-view />
      </main>
    </div>
    
    <!-- 底部 footer -->
    <footer class="layout-footer">
      <div class="footer-content">
        <p>© 2025 后台管理系统</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Layout',
  data() {
    return {
      username: localStorage.getItem('username') || '管理员',
      role: parseInt(localStorage.getItem('role'))
    };
  },
  methods: {
    navigate(path) {
      // 检查当前路径，避免重复导航
      if (this.$route.fullPath === path) {
        return;
      }
      this.$router.push(path).catch(error => {
        // 忽略重复导航错误
        if (error.name !== 'NavigationDuplicated') {
          console.error('导航错误:', error);
        }
      });
    },
    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('userId');
      localStorage.removeItem('username');
      localStorage.removeItem('merchantId');
      this.$router.push('/login').catch(error => {
        console.error('导航错误:', error);
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    // 检查是否登录
    const token = localStorage.getItem('token');
    if (!token) {
      next('/login');
    } else {
      next();
    }
  }
};
</script>

<style>
/* 全局样式重置 - Premium Figure Theme */
:root {
  /* 背景色系 - 深邃黑金/紫调 */
  --bg-dark-deep: #0b0c15;       /* 页面主背景 - 近乎纯黑 */
  --bg-dark-secondary: #161722;  /* 卡片/侧边栏背景 */
  --bg-dark-header: rgba(22, 23, 34, 0.8);     /* 顶栏背景 - 半透明 */
  --bg-dark-hover: #232433;      /* 悬停/选中背景 */
  
  /* 文字色系 */
  --text-light-primary: #ffffff;   /* 主标题 */
  --text-light-secondary: #a0a0b0; /* 次级文字 */
  --text-light-muted: #6b6b7b;     /* 弱化文字 */
  
  /* 边框色系 */
  --border-color-dark: #2a2b3d;    /* 边框颜色 */
  
  /* 品牌色 - 霓虹质感 */
  --primary-color: #6c5ce7;        /* 霓虹紫 */
  --primary-color-hover: #81ecec;  /* 霓虹青 (Hover) */
  --accent-color: #fd79a8;         /* 强调色 (粉) */
  
  /* 阴影 & 发光 */
  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.2);
  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.3), 0 0 8px rgba(108, 92, 231, 0.2); /* 带紫色微光 */
  --shadow-lg: 0 10px 24px rgba(0, 0, 0, 0.4), 0 0 15px rgba(108, 92, 231, 0.3);
  
  /* 圆角 */
  --radius-md: 8px;
  --radius-lg: 16px;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-light-primary);
  background-color: var(--bg-dark-deep);
  background-image: radial-gradient(circle at 10% 20%, rgba(108, 92, 231, 0.05) 0%, transparent 20%),
                    radial-gradient(circle at 90% 80%, rgba(253, 121, 168, 0.05) 0%, transparent 20%);
  line-height: 1.6;
}

/* 滚动条美化 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-track {
  background: var(--bg-dark-deep);
}
::-webkit-scrollbar-thumb {
  background: var(--border-color-dark);
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background: var(--primary-color);
}

/* Element UI Dark Theme Deep Customization */
/* Card - Glassmorphism touch */
.el-card {
  background-color: var(--bg-dark-secondary) !important;
  border: 1px solid var(--border-color-dark) !important;
  color: var(--text-light-primary) !important;
  border-radius: var(--radius-lg) !important;
  box-shadow: var(--shadow-sm) !important;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.el-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md) !important;
  border-color: rgba(108, 92, 231, 0.3) !important;
}

.el-card__header {
  border-bottom: 1px solid var(--border-color-dark) !important;
  padding: 16px 24px !important;
  font-weight: 600;
  letter-spacing: 0.5px;
}

/* Button */
.el-button--primary {
  background: linear-gradient(135deg, var(--primary-color), #5e4dd8) !important;
  border: none !important;
  box-shadow: 0 4px 12px rgba(108, 92, 231, 0.4);
  font-weight: 600;
  letter-spacing: 0.5px;
}

.el-button--primary:hover, .el-button--primary:focus {
  background: linear-gradient(135deg, #7d6ef0, #6c5ce7) !important;
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(108, 92, 231, 0.5);
}

/* Tag */
.el-tag {
  border-radius: 4px;
  font-weight: 600;
}
.el-tag--success {
  background-color: rgba(16, 185, 129, 0.1) !important;
  border-color: rgba(16, 185, 129, 0.2) !important;
  color: #10b981 !important;
}
.el-tag--danger {
  background-color: rgba(239, 68, 68, 0.1) !important;
  border-color: rgba(239, 68, 68, 0.2) !important;
  color: #ef4444 !important;
}

/* Table */
.el-table {
  background-color: transparent !important;
  color: var(--text-light-secondary) !important;
  --el-table-border-color: var(--border-color-dark);
  --el-table-header-bg-color: var(--bg-dark-secondary);
  --el-table-row-hover-bg-color: var(--bg-dark-hover);
}

.el-table th {
  background-color: rgba(35, 36, 51, 0.5) !important;
  border-bottom: 1px solid var(--border-color-dark) !important;
  color: var(--text-light-primary) !important;
  font-weight: 600 !important;
}

.el-table tr {
  background-color: transparent !important;
}

.el-table td {
  border-bottom: 1px solid var(--border-color-dark) !important;
}

.el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: var(--bg-dark-hover) !important;
}

.el-table::before, .el-table::after {
  background-color: var(--border-color-dark) !important;
}

/* Dialog */
.el-dialog {
  background-color: var(--bg-dark-secondary) !important;
  border-radius: var(--radius-lg) !important;
  border: 1px solid var(--border-color-dark) !important;
  box-shadow: var(--shadow-lg) !important;
}

.el-dialog__title {
  color: var(--text-light-primary) !important;
  font-weight: 600;
}

.el-dialog__body {
  color: var(--text-light-secondary) !important;
}

/* Input/Select */
.el-input__inner, .el-textarea__inner {
  background-color: rgba(0, 0, 0, 0.2) !important;
  border: 1px solid var(--border-color-dark) !important;
  color: var(--text-light-primary) !important;
  border-radius: var(--radius-md) !important;
}

.el-input__inner:focus, .el-textarea__inner:focus {
  border-color: var(--primary-color) !important;
  box-shadow: 0 0 0 2px rgba(108, 92, 231, 0.2);
}

/* Pagination */
.el-pagination.is-background .btn-next, 
.el-pagination.is-background .btn-prev, 
.el-pagination.is-background .el-pager li {
  background-color: var(--bg-dark-secondary) !important;
  color: var(--text-light-secondary) !important;
  border: 1px solid var(--border-color-dark);
  border-radius: 4px;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: var(--primary-color) !important;
  color: #fff !important;
  border-color: var(--primary-color) !important;
  box-shadow: 0 2px 8px rgba(108, 92, 231, 0.4);
  font-weight: 600;
}

.el-dialog__body {
  color: var(--text-light-secondary) !important;
  padding: 24px !important;
}

.el-dialog__headerbtn .el-dialog__close {
  color: var(--text-light-muted) !important;
}

.el-dialog__headerbtn:hover .el-dialog__close {
  color: var(--primary-color) !important;
}

/* Form & Inputs */
.el-input__inner, .el-textarea__inner {
  background-color: var(--bg-dark-deep) !important;
  border: 1px solid var(--border-color-dark) !important;
  color: var(--text-light-primary) !important;
  border-radius: 6px !important;
  transition: all 0.2s ease !important;
}

.el-input__inner:focus, .el-textarea__inner:focus {
  border-color: var(--primary-color) !important;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2) !important;
}

.el-form-item__label {
  color: var(--text-light-secondary) !important;
}

/* Buttons */
.el-button--primary {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  font-weight: 500;
}

.el-button--primary:hover, .el-button--primary:focus {
  background-color: var(--primary-color-hover) !important;
  border-color: var(--primary-color-hover) !important;
}

.el-button--default {
  background-color: transparent !important;
  border-color: var(--border-color-dark) !important;
  color: var(--text-light-secondary) !important;
}

.el-button--default:hover {
  border-color: var(--primary-color) !important;
  color: var(--primary-color) !important;
  background-color: rgba(59, 130, 246, 0.1) !important;
}

.el-button--text {
  color: var(--primary-color) !important;
}

.el-button--text:hover {
  color: var(--primary-color-hover) !important;
}

/* Pagination */
.el-pagination__total, .el-pagination__jump {
  color: var(--text-light-muted) !important;
}

.el-pagination button:disabled {
  background-color: transparent !important;
  color: var(--text-light-muted) !important;
}

.el-pagination .btn-prev, .el-pagination .btn-next {
  background-color: transparent !important;
  color: var(--text-light-secondary) !important;
}

.el-pager li {
  background-color: transparent !important;
  color: var(--text-light-secondary) !important;
}

.el-pager li.active {
  color: var(--primary-color) !important;
}

/* Layout Specifics */
.layout-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  background-color: var(--bg-dark-deep);
}

/* Header */
.layout-header {
  height: 70px; /* 稍微加高 */
  background-color: rgba(22, 23, 34, 0.7); /* 半透明 */
  backdrop-filter: blur(12px); /* 毛玻璃效果 */
  border-bottom: 1px solid rgba(108, 92, 231, 0.1); /* 极淡的紫色边框 */
  display: flex;
  align-items: center;
  padding: 0 32px;
  position: relative;
  z-index: 100;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.logo {
  font-size: 22px;
  font-weight: 800;
  margin: 0;
  font-family: 'Segoe UI', sans-serif;
  /* 霓虹渐变色 Logo */
  background: linear-gradient(135deg, #a29bfe 0%, #6c5ce7 50%, #00cec9 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  filter: drop-shadow(0 0 5px rgba(108, 92, 231, 0.5));
}

.logo::before {
  content: '';
  display: inline-block;
  width: 32px;
  height: 32px;
  /* 简单的 Logo 图标模拟 */
  background: conic-gradient(from 0deg, #6c5ce7, #00cec9, #fd79a8, #6c5ce7);
  margin-right: 16px;
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(108, 92, 231, 0.6);
  animation: spin 10s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.user-info {
  display: flex;
  align-items: center;
  color: var(--text-light-primary);
  font-size: 14px;
}

.user-info span {
  font-weight: 600;
  margin-right: 24px;
  color: #dfe6e9;
}

.logout-btn {
  padding: 8px 20px;
  background: linear-gradient(90deg, rgba(253, 121, 168, 0.1), rgba(108, 92, 231, 0.1));
  border: 1px solid rgba(108, 92, 231, 0.3);
  border-radius: 20px;
  color: var(--primary-color-hover);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.logout-btn:hover {
  background: linear-gradient(90deg, rgba(253, 121, 168, 0.2), rgba(108, 92, 231, 0.2));
  border-color: var(--primary-color);
  box-shadow: 0 0 15px rgba(108, 92, 231, 0.4);
  transform: translateY(-1px);
}

/* Main Area */
.layout-main {
  display: flex;
  flex: 1;
  overflow: hidden;
  position: relative;
}

/* Sidebar */
.layout-aside {
  width: 260px;
  background-color: rgba(22, 23, 34, 0.6); /* 半透明背景 */
  backdrop-filter: blur(10px);
  color: var(--text-light-secondary);
  overflow-y: auto;
  border-right: 1px solid rgba(255, 255, 255, 0.03);
  display: flex;
  flex-direction: column;
}

.nav-menu {
  padding: 24px 16px;
  flex: 1;
}

.nav-menu ul {
  list-style: none;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  margin-bottom: 8px;
  cursor: pointer;
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--text-light-muted);
  position: relative;
  overflow: hidden;
}

.nav-icon {
  margin-right: 16px;
  font-size: 20px;
  transition: all 0.3s;
}

.nav-text {
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.5px;
}

/* Hover Effect */
.nav-item:hover {
  background-color: rgba(255, 255, 255, 0.03);
  color: var(--text-light-primary);
  transform: translateX(4px);
}

.nav-item:hover .nav-icon {
  color: var(--primary-color-hover);
  text-shadow: 0 0 8px var(--primary-color);
}

/* Active State */
.nav-item.active {
  background: linear-gradient(90deg, rgba(108, 92, 231, 0.15), rgba(108, 92, 231, 0.05));
  color: #fff;
  border-left: 3px solid var(--primary-color);
}

.nav-item.active .nav-icon {
  color: var(--primary-color-hover);
  filter: drop-shadow(0 0 5px var(--primary-color));
}

.nav-item.active::after {
  content: '';
  position: absolute;
  right: 12px;
  width: 6px;
  height: 6px;
  background-color: var(--accent-color);
  border-radius: 50%;
  box-shadow: 0 0 8px var(--accent-color);
}

/* Content Area */
.layout-content {
  flex: 1;
  padding: 32px;
  overflow-y: auto;
  background: transparent; /* 背景由 body 统一控制 */
}

/* Footer */
.layout-footer {
  height: 48px;
  background-color: transparent;
  border-top: 1px solid rgba(255, 255, 255, 0.03);
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--text-light-muted);
  font-size: 12px;
}


/* Scrollbar Customization */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: var(--border-color-dark);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--text-light-muted);
}
</style>
